import React from 'react'

const OurServices = () => {
    const g1 = 'text-xl font-bold font-[Montserrat] mt-20 flex items-center'

  return (
    <div className="bg-sec1 flex flex-col items-center justify-center pb-20">
       <div className="text-prime text-2xl font-semibold font-[Montserrat] flex items-center justify-center pt-20">
            Our Services
        </div>
          <div className="grid grid-cols-2 gap-10 mt-10">
            <div className="flex flex-col items-end">
                <div className={g1}>
                      Product Discovery <ion-icon style={{ marginLeft: '04.5rem', marginRight: '1rem' }} name="arrow-forward-outline"></ion-icon>
                  </div>
                  <div className={g1}>
                    Web App Development <ion-icon style={{ marginLeft: '04.5rem', marginRight: '1rem' }} name="arrow-forward-outline"></ion-icon>
                  </div>
                  <div className={g1}>
                    Mobile App Development <ion-icon style={{ marginLeft: '04.5rem', marginRight: '1rem' }} name="arrow-forward-outline"></ion-icon>
                  </div>
                  <div className={g1}>
                    MVP App Development <ion-icon style={{ marginLeft: '04.5rem', marginRight: '1rem' }} name="arrow-forward-outline"></ion-icon>
                  </div>
                  <div className={g1}>
                    SaaS App Development <ion-icon style={{ marginLeft: '04.5rem', marginRight: '1rem' }} name="arrow-forward-outline"></ion-icon>
                </div>
              </div>
              <div className="flex flex-col items-start">
                <p className="text-lg font-medium font-[Montserrat] mt-20 pr-60">
                    Convert your idea into an actionable blueprint. Discover potential customers, problem statements, aspirations, and end goals.
                  </p>
                  <div className="text-lg font-medium font-[Montserrat] mt-14 pr-60">
                    Build responsive and scalable web applications. Get delightful high-performant apps that deliver the best UI/UX experience.
                  </div>
                  <div className="text-lg font-medium font-[Montserrat] mt-12 pr-60">
                    Get native and hybrid mobile applications that will be the perfect solution to your complex business needs.
                  </div>
                  <div className="text-lg font-medium font-[Montserrat] mt-14 pr-60">
                    Create a responsive and scalable MVP from zero to the first version of a web or mobile app to take your business to the next level.
                  </div>
                  <div className="text-lg font-medium font-[Montserrat] mt-14 pr-60">
                    Create a responsive and scalable MVP from zero to the first version of a web or mobile app to take your business to the next level.
                </div>
            </div>
        </div>
    </div>
  )
}

export default OurServices;
